import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { Button } from '@shared/componentsStyled/Button'
import Link from 'next/link'
import { RegionalPagesPath } from 'regions/runtime-components/pages-props'
import styled from 'styled-components'

export function SectionFirstDeposit() {
	return (
		<Section fullWidth>
			<ViewRoot>
				<ViewContent>
					<Text>Специальное предложение</Text>
					<TextTitle>
					Первое «Сбережение» <br /> с высокой доходностью
					</TextTitle>
					<Text>
						Возможно досрочное снятие без потери процентов, частичное снятие и пополнение — как по
						вкладу в банке
					</Text>
					<Text>Доходность зафиксирована в договоре</Text>
					<Text>Оформление онлайн</Text>
					<Link href={RegionalPagesPath.invest + '#calculator'}>
						<ButtonStyled type='button'>Рассчитать доход</ButtonStyled>
					</Link>
				</ViewContent>
				<Background name='background-safe' alt='' />
				<Safe name='safe' alt='' />
			</ViewRoot>
		</Section>
	)
}

const Background = styled(Image)(({ theme }) => ({
	display: 'none',
	objectFit: 'contain',
	zIndex: 1,

	[theme.mediaQueries.mediaMinWidthTablet]: {
		display: 'flex',
		height: '100%',
		width: '100%',
	},
}))

const Safe = styled(Image)(({ theme }) => ({
	display: 'none',
	objectFit: 'contain',
	zIndex: 10,

	[theme.mediaQueries.mediaMinWidthTablet]: {
		display: 'flex',
		height: '90%',
		width: '90%',
	},
}))

const ButtonStyled = styled(Button)(({ theme }) => ({
	display: 'block',
	width: 'fit-content',
	marginBottom: 30,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 51,
	},
}))

const ViewRoot = styled.div(({ theme }) => ({
	display: 'flex',
	overflow: 'hidden',
	marginTop: 24,
	margin: 0,
	padding: 0,
	backgroundColor: theme.colors.bluealice,
	borderRadius: 20,
	position: 'relative',
	marginBottom: 20,

	picture: {
		position: 'absolute',
		bottom: -15,
		right: -20,
	},

	[theme.mediaQueries.mediaMinWidthMobile]: {
		borderRadius: 40,
	},
}))
const ViewContent = styled.div(({ theme }) => ({
	paddingTop: 20,
	paddingLeft: 20,
	display: 'flex',
	width: '100%',
	flexDirection: 'column',
	paddingRight: 20,
	zIndex: 1,
	[theme.mediaQueries.mediaMinWidthTablet]: {
		paddingTop: 40,
		maxWidth: '80%',
		paddingLeft: 60,
		paddingRight: 0,
		marginRight: 'auto',
	},
}))

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 10,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text18_24,
	marginBottom: 15,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text24_32,
		marginBottom: 30,
		maxWidth: '75%',
	},
}))
